const styles = theme => ({
  container: {
    padding: '20px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    background: theme.palette.primary.white,
  },
  avatarImg: {
    height: '64px',
    width: '64px',
  },
  marginTop: { marginTop: '20px' },
  titleImage: { maxWidth: '100%' },
  marginBottom: { marginBottom: '20px' },
  innerCardGrid: {
    padding: '16px',
    '& h6': {
      fontSize: '14px',
    },
  },
  adgmSelect: {
    maxWidth: '500px',
  },
  hr: {
    width: '100%',
    height: '1px',
    background: '#DADEE7',
    border: 'none',
    margin: '24px 0px',
  },
  strongText: {
    fontSize: '14px',
    fontWeight: '600',
  },
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
  },
  titleHead: {
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    // padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      innerCardGrid: {
        padding: '24px',
        '& h6': {
          fontSize: '1rem',
        },
      },
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
      '& $textDanger': {
        color: theme.palette.primary.main,
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
    '& $textRight': {
      fontSize: '20px',
      fontWeight: '600',
    },
  },
  textDanger: {},
  textRight: {
    marginLeft: 'auto',
  },
  titleHeadActions: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    '& button': {
      '& > span > p': {
        color: theme.palette.primary.main,
        fontWeight: 600,
        textTransform: 'none',
      },
    },
    '& > span': {
      margin: '0px 4px',
    },
  },

  headsubtitle: {
    marginLeft: 'auto',
    fontSize: '12px',
    fontWeight: '500',
  },
  innerCard: {
    padding: '12px 16px',
  },
  mediumButton: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    padding: '1em 3em',
    '&:disabled': {
      backgroundColor: `${theme.palette.primary.black20} !important`,
      color: `${theme.palette.primary.white} !important`,
    },
  },

  panelTitle: {
    padding: '10px 24px',
    background: theme.palette.primary.grey,
    border: '1px solid #CED1D6',
    borderRight: 'none',
    borderLeft: 'none',
    '& h6': {
      fontSize: '20px',
    },
  },
  subPanel: {
    padding: '10px 24px',
  },
  infoAlertBorder: {
    paddingBottom: '12px',
    borderBottom: '1px solid #EBEEF3',
  },

  hidden: {
    display: 'none',
  },
  '@media (max-width: 645px)': {
    inputGridContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
    fetchTextField: {
      gridTemplateColumns: '9fr 3fr',
      columnGap: '6px',
    },
    panelTitle: {
      '& h6': {
        fontSize: '16px',
      },
    },
    accordianTitle: {
      '& p': {
        fontSize: '14px !important',
      },
    },
  },
  '@media (max-width:767px)': {
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    titleHead: {
      flexWrap: 'wrap',
      '& $textRight': {
        fontSize: '16px',
      },
    },
    formControl: {
      gap: '16px',
    },

    flexCenter: {
      flexWrap: 'wrap',
      '& $ownerAvatarimg': {
        marginRight: '10px',
        height: '44px',
        width: '44px',
        background: '#EBEEF3',
      },
      '& $sellerName': {
        color: theme.palette.primary.acscent,
        fontWeight: 600,
        fontSize: '14px',
      },
      '& $addSellerButton': {
        width: '100%',
        marginTop: '16px',
      },
      '& $brokerTextHolder': {
        '& $buyerNumber': {
          fontSize: '14px',
        },
        '& $buyerName': {
          fontSize: '14px',
        },
      },
    },
  },
  '@media (min-width: 768px)': {
    inputGridContainer: {
      padding: '16px 24px',
    },
    titleHead: {
      // padding: '16px 0px',
      '& h1': {
        fontSize: '20px',
      },
    },
    headsubtitle: {
      fontSize: '16px',
      fontWeight: '400',
    },
    largeButton: {
      height: '60px',
      minWidth: '228px',
      borderRadius: '13.6111px',
      border: '1.36111px solid #342D3D',
      '& img': {
        width: '17px',
        height: '17px',
      },
      '& p': {
        fontSize: '16px',
      },
    },
  },
  '@media (min-width: 992px)': {
    innerCard: {
      padding: '24px',
    },
    innerCardNoPadding: {
      padding: '0px',
    },
    formControl: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
});

export default styles;
